export default __webpack_public_path__ + "static/media/Banner_Pack_Series2_News.0283d61e.png";